import { ASSET_PRODUCT_TYPE } from '@shootsta/common-domain-data';

const { CAST, PITCH } = ASSET_PRODUCT_TYPE;

export const EXCLUDED_ORIGINAL_QUALITY_PRODUCTS = [CAST, PITCH];